import { useEffectOnce } from '@dni-react-hooks/use-effect-once'
import { useThirtyPartyBindIdentity } from '../../../hooks/useThirtyPartyBindIdentity'

export function CouponReferralBindLine() {
  const { bindLine } = useThirtyPartyBindIdentity()

  useEffectOnce(() => {
    bindLine()
  })

  return null
}
